import queryString from 'query-string'

import {
  GET_UPLOADS,
  SET_SEARCH
} from '../../redux/uploads/types'

import { get } from '../fetch'

export const getUploads = (search, skip, take, sort) => dispatch => dispatch(
  get(GET_UPLOADS.REQUEST, `airline/uploads?${queryString.stringify({search, skip, take, sortBy: sort.key, sortDirection: sort.direction})}`)
)

export const setSearch = search => dispatch => dispatch({
  type: SET_SEARCH,
  payload: {
    search
  }
})